var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreaterOrEqualThan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#GreaterOrEqualThan_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89 8.633L.173 12.008v-1.164l5.031-2.438V8.36L.172 5.58V4.405L6.89 8.172v.46zm9.266-1.445H8.813V6.155h7.343v1.032zm0 3.328H8.813V9.484h7.343v1.032z",
    fill: "#C6C6C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "GreaterOrEqualThan_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

export default SvgGreaterOrEqualThan;